import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  "class": "fcon_triggers_wrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_action_map = _resolveComponent("action-map");
  var _component_action_adder = _resolveComponent("action-adder");
  var _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.actions, function (action, actionIndex) {
    return _openBlock(), _createElementBlock("div", {
      key: actionIndex,
      "class": "fc_trigger_map"
    }, [_createVNode(_component_action_map, {
      mock_data: $props.mock_data,
      onUpdate: _cache[0] || (_cache[0] = function ($event) {
        return $options.triggerUpdate();
      }),
      action: action,
      provider_info: $props.all_actions[action.action_provider]
    }, null, 8 /* PROPS */, ["mock_data", "action", "provider_info"])]);
  }), 128 /* KEYED_FRAGMENT */)), $data.show_adder ? (_openBlock(), _createBlock(_component_action_adder, {
    key: 0,
    onSuccess: $options.appendAction,
    all_actions: $props.all_actions
  }, null, 8 /* PROPS */, ["onSuccess", "all_actions"])) : (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    style: {
      "margin-top": "30px"
    },
    size: "small",
    type: "info",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $data.show_adder = true;
    })
  }, {
    "default": _withCtx(function () {
      return _cache[2] || (_cache[2] = [_createTextVNode("Add Another Action")]);
    }),
    _: 1 /* STABLE */
  }))]);
}